import {
  Flex,
} from '@smarterservices/smarter-ui';
import VideoContainer from './VideoContainer';
import SidebarVideo from './SidebarVideo';
import { usePlayerStore, getStore } from '../../../stores/StoreContext';
import { useState, useEffect } from 'react';
import { useFirstPaneContext } from '../../Common/SplitView/SplitViewContext';

const Sidebar = () => {
  const PlayerStore = getStore('playerStore');

  //const currentTime = usePlayerStore((state) => state.currentTime);
  const sidebarTracksAtTime = usePlayerStore((state) => state.sidebarTracksAtTime);
  const sidebarTracks = usePlayerStore((state) => state.sidebarTracks);

  const [trackDimensions, setTrackDimensions] = useState({
    width: '100px',
    height: '100px',
  });

  const { width, height } = useFirstPaneContext();

  const sidebarItemGap = 5;

  useEffect(() => {

    let perTrackWidth = width;
    let perTrackHeight = height;

    perTrackHeight = (height / sidebarTracksAtTime);

    const gapAdjustment = (sidebarTracksAtTime - 1) * sidebarItemGap;
    perTrackHeight = perTrackHeight - gapAdjustment - 1; // needed a 1px adjustment...

    // Update track dimensions
    setTrackDimensions({ width: perTrackWidth, height: perTrackHeight });

  }, [sidebarTracksAtTime, width, height]);

  return (
    <Flex
      as="div"
      direction="column"
      gap="small"
      height="100%"
      withVisualDebug={false}
      padding="none"
      themeOverride={{
        gapSmall: `${sidebarItemGap}px`,
      }}
    >
      {Object.keys(sidebarTracks).map((SessionTrackId) => {
        const track = sidebarTracks[SessionTrackId];
        return (
          // Key includes lastUpdated timestamp to force SidebarVideo remount on reconnection
          // This ensures sidebar videos properly re-render when tracks reconnect
          <SidebarVideo
            key={`sidebar_${SessionTrackId}_${track?.lastUpdated || 0}`}
            SessionTrack={track}
            width={width}
            height={trackDimensions.height}
          />
        );
      })}
    </Flex>
  );
};

export default Sidebar;
